export const contactAdminTomazz = (message = '') => {
  const phoneNumber = '6281180895368'
  const encodedMessage = encodeURIComponent(message)
  const url = isIOS()
    ? `https://api.whatsapp.com/send/?phone=${phoneNumber}&text=${encodedMessage}`
    : `https://wa.me/${phoneNumber}?text=${encodedMessage}`
  window.open(url, '_blank')
}
const isIOS = () => {
  if (typeof navigator === 'undefined') return false
  return /iPad|iPhone|iPod|Macintosh/.test(navigator.userAgent) && !window.MSStream
}
